import React, { Fragment } from "react";
import { Form } from "react-bootstrap";
import DescPopover from "../other/DescPopover";
import $ from "jquery";

const NameInput = (props) => {
    const { value, onChangeValue, req, labelTxt, placeholderTxt, name, helper, id, readOnly, classStyle } = props;
    return (
        <Fragment>
            <Form.Group>
                {labelTxt && (
                    <Form.Label>
                        {labelTxt} {req && <span className="required">*</span>}
                        {helper && <DescPopover popoverTxt={<p>{helper}</p>} />}
                    </Form.Label>
                )}
                <Form.Control
                    type="text"
                    placeholder={placeholderTxt}
                    name={name}
                    id={id}
                    value={value}
                    onChange={(e) => {
                        $(`#${id}`).removeClass("is-invalid");
                        onChangeValue(e);
                    }}
                    className={req ? `req ${classStyle}` : `${classStyle}`}
                    readOnly={readOnly ? true : false}
                />
            </Form.Group>
        </Fragment>
    );
};

export default NameInput;
